function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M256,0c-8,0-15.9,2-23,6L45.5,111.3c-14.3,8.1-23.3,23.1-23.3,39.3v210.7c0,16.2,8.9,31.2,23.3,39.3L233,506 c7.1,4,15.1,6,23,6c8,0,15.9-2,23-6l187.5-105.3c14.3-8.1,23.3-23.2,23.3-39.4V150.7c0-16.2-8.9-31.3-23.3-39.3L279,6 C271.9,2,264,0,256,0z M256,122.4c42.1,0,81,19.5,106.2,52.8l-48.8,28.2c-14.7-16-35.5-25.3-57.5-25.3c-43,0-77.9,35-77.9,77.9 s35,77.9,77.9,77.9c22,0,42.8-9.3,57.5-25.3l48.8,28.2C337,370,298.1,389.6,256,389.6c-73.7,0-133.6-59.9-133.6-133.6 S182.3,122.4,256,122.4z M367.3,200.3h22.3v22.3h22.3v-22.3h22.3v22.3h22.3v22.3h-22.3v22.3h22.3v22.3h-22.3v22.3h-22.3v-22.3h-22.3 v22.3h-22.3v-22.3h-22.3v-22.3h22.3v-22.3h-22.3v-22.3h22.3V200.3z M389.6,244.9v22.3h22.3v-22.3H389.6z"
});

function SvgCsharp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsharp);
export default __webpack_public_path__ + "static/media/csharp.bfcffdfd.svg";
export { ForwardRef as ReactComponent };